(function () {
  'use strict';

  var VERSION = '2026-07-02-singleton-pending';
  var ROOT_SELECTOR = '[data-centauri-c22]';
  var READY_CLASS = 'is-c22-reveal-ready';
  var PENDING_CLASS = 'is-c22-reveal-pending';
  var states = new WeakMap();

  if (window.CentauriC22AcousticExploded && window.CentauriC22AcousticExploded.version === VERSION) {
    window.CentauriC22AcousticExploded.init(document);
    return;
  }

  function rootsFor(scope) {
    var base = scope && scope.querySelectorAll ? scope : document;
    var roots = [];

    if (base.matches && base.matches(ROOT_SELECTOR)) roots.push(base);

    var found = base.querySelectorAll(ROOT_SELECTOR);
    for (var i = 0; i < found.length; i += 1) roots.push(found[i]);

    return roots;
  }

  function reduceMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function reveal(root) {
    root.classList.remove(PENDING_CLASS);
    root.classList.add(READY_CLASS);
    root.setAttribute('data-c22-reveal-ready', 'true');
  }

  function setup(root) {
    if (!root || states.has(root)) return;

    var state = { observer: null };
    states.set(root, state);

    if (reduceMotion() || !('IntersectionObserver' in window)) {
      reveal(root);
      return;
    }

    root.classList.add(PENDING_CLASS);

    state.observer = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i += 1) {
        if (!entries[i].isIntersecting) continue;
        reveal(root);
        if (state.observer) state.observer.disconnect();
        state.observer = null;
        break;
      }
    }, { rootMargin: '0px 0px -20% 0px', threshold: 0.18 });

    state.observer.observe(root);
  }

  function teardown(root) {
    var state = states.get(root);
    if (!state) return;
    if (state.observer) state.observer.disconnect();
    root.classList.remove(PENDING_CLASS);
    root.classList.remove(READY_CLASS);
    root.removeAttribute('data-c22-reveal-ready');
    states.delete(root);
  }

  function init(scope) {
    var roots = rootsFor(scope);
    for (var i = 0; i < roots.length; i += 1) setup(roots[i]);
  }

  function unload(scope) {
    var roots = rootsFor(scope);
    for (var i = 0; i < roots.length; i += 1) teardown(roots[i]);
  }

  window.CentauriC22AcousticExploded = {
    version: VERSION,
    init: init,
    unload: unload
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event && event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    unload(event && event.target);
  });

  document.addEventListener('shopify:block:select', function (event) {
    init(event && event.target);
    var target = event && event.target;
    var root = target && target.closest ? target.closest(ROOT_SELECTOR) : null;
    if (root) reveal(root);
  });
})();
